var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"history-container",class:{ hidden: !_vm.opened },attrs:{"id":"history-container"}},[_c('AttendanceHistory',{attrs:{"patientId":_vm.attendance ? _vm.attendance.patient.id : null}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }